import { Link } from '@remix-run/react'

const Hero = () => {
	return (
		<header>
			<img
				src="img/header-decoration.svg"
				alt="header-decoration"
				width={1022}
				height={952}
				className="absolute left-0 top-0 -z-20 hidden sm:block"
			/>
			<img
				src="img/mobile-landing-background.svg"
				alt="header-decoration"
				width={1022}
				height={952}
				className="absolute left-0 top-0 -z-20 sm:hidden"
			/>
			{/* mobile */}
			<h1 className="text-center text-4xl font-extrabold sm:hidden">
				Ušetříme vám náklady, <br />
				zvýšíme tržby a přineseme <br />
				<span className="text-primary">nové zákazníky 🤝</span>
			</h1>
			<div className="w-full space-y-4  sm:mt-32 sm:grid sm:grid-cols-2">
				<div className="flex justify-center">
					<img
						src="img/ladning-iphones.webp"
						alt="ihpones"
						width={340}
						height={511}
						className="hidden sm:block"
					/>
					{/* mobile */}
					<img
						src="img/ladning-iphones.webp"
						alt="ihpones"
						width={180}
						height={352}
						className="mt-4 sm:hidden"
					/>
				</div>
				{/* desktop */}
				<div className="hidden justify-center gap-8 sm:flex sm:flex-col">
					<h1 className="text-4xl font-extrabold">
						Ušetříme vám náklady, <br />
						zvýšíme tržby a přineseme <br />
						<span className="text-primary">nové zákazníky 🤝</span>
					</h1>
					<p>
						A to vše díky mobilní aplikaci pro váš e-shop, kterou můžete mít{' '}
						<br />
						spuštěnou do 14 dnů od přečtení těchto řádků.
					</p>
					<button className="mt-10 w-[206px] rounded-[90px] bg-secondary px-10 py-4 text-white">
						<Link to="#benefits">Chci vědět více</Link>
					</button>
				</div>
				{/* mobile */}
				<div className="text-center sm:hidden">
					<p className="mx-8 text-xs">
						A to vše díky mobilní aplikaci pro váš e-shop, kterou můžete mít
						spuštěnou do 14 dnů od přečtení těchto řádků.
					</p>
					<button className="mt-4 min-w-[206px] rounded-[90px] bg-secondary px-10 py-4 text-white">
						<Link to="#benefits">Chci vědět více</Link>
					</button>
				</div>
			</div>
		</header>
	)
}

export default Hero
